import { storage, path } from '@commons';
import { setupZendeskAuth } from './zendeskServiceAuth';

export const handleZendeskLoaded = () => {
  try {
    const user = JSON.parse(storage.get(path.sessionUser));

    if (user && user?.id) {
      setTimeout(() => {
        setupZendeskAuth(user);
      }, 1000);
    } else {
      console.warn('Usuário não encontrado no storage ou sem ID');
    }
  } catch (error) {
    console.error('Erro ao carregar dados do usuário para o Zendesk:', error);
  }
};
